import Bowser from "bowser";
import {appConfig, skipTheseSubDomainsRegExp} from "../config/defaultConfig";
import {
  getSessionUser,
  setAuthToken,
  setRecentlyViewedIncidentId,
  setSessionUser
} from "../config/localStorage";
import {FieldNames} from "../models/fields";

export const clearSession = () => {
  setSessionUser(null);
  setAuthToken(null);
  setRecentlyViewedIncidentId(null);
};

export const getCurrentUserId = () => {
  const userInfo = getSessionUser();
  return userInfo && userInfo.user && userInfo.user[FieldNames.userId]
    ? userInfo.user[FieldNames.userId]
    : "";
};

export const getIDP = (authData = getSessionUser()) => {
  return authData?.idp?.id;
};

export const getUserEmail = (authData = getSessionUser()) => {
  return authData?.user?.["user-email"] || "-";
};

export const isUnentitled = (authData = getSessionUser()) => {
  const activationStatus = authData?.org?.["activation-status"];
  const scimStatus = authData?.org?.["scim-status"];
  return (
    activationStatus === "waiting-activation" ||
    scimStatus === "waiting-activation" ||
    (!activationStatus && !scimStatus)
  );
};

export const getUserOrgId = (authData = getSessionUser()) => {
  return authData?.org?.id;
};

export const isInSkipDomainList = (emailAddress) => {
  if (emailAddress) {
    const domainPos = emailAddress.search("@");
    if (domainPos > 0) {
      const emailDomain = emailAddress.slice(domainPos + 1);
      if (emailDomain) {
        return skipTheseSubDomainsRegExp.some((d) =>
          d.test(emailDomain.toLowerCase())
        );
      }
    }
  }
  return false;
};
